import { parsePhoneNumber, ParseError, parsePhoneNumberWithError } from 'libphonenumber-js'
import 'libphonenumber-js/mobile'
window.PhoneValidator = parsePhoneNumber
window.PhoneValidatorError = ParseError
window.PhoneValidatorWithError = parsePhoneNumberWithError